// extracted by mini-css-extract-plugin
module.exports = {"stack":"styles-module--stack--201Qq"};